import styled from "styled-components";

const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  .box {
    display: flex;
    align-items: center;
  }
  .pagination-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #93a2dd;
    font-size: 13px;
    line-height: 20px;
    padding: 3px;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 5px;
    background-color: #fbfbff;
    min-width: 30px;
    transition: 0.2s;
    svg {
      max-width: 15px;
    }
    &.active {
      background-color: #5d78ff;
      color: white;
    }
    &.arrow {
      background-color: #f0f3ff;
      path {
        fill: #93a2dd;
      }
      &[disabled] {
        pointer-events: none;
        background-color: #fbfbff;
        path {
          fill: #dfe3f5;
        }
      }
    }
  }
  .pagination-select {
    border: none;
    cursor: pointer;
    border-radius: 4px;
    background-color: #f0f3ff;
    padding: 4px 10px;
    padding-left: 4px;
    font-family: "Poppins";
    font-size: 13px;
    font-weight: 500;
    color: #93a2dd;
  }
  .pagination-info {
    margin-left: 15px;
    font-size: 13px;
    line-height: 20px;
    font-weight: 300;
    color: #646c9a;
  }
`;
export default StyledPagination;
